export default __webpack_public_path__ + "static/media/canvas-with-landscape.8839378c.svg";